import React, { useEffect, useState, useTransition } from "react";
import styled from "@emotion/styled";

import Button from "shared/components/Button";
import { css } from "@emotion/react";
import JoinRemaxForm from "./form";
import { useWidth } from "custom-hooks/use-width.hook";
import { useMutation } from "@tanstack/react-query";
import { getStatistics } from "api/statistics-services.request";
import { useTranslations } from "next-intl";

function Statistic() {
  const translation = useTranslations("join.statistic");
  const translationStatsLabel = useTranslations("join.statistic.statsLabel");
  const translationWhyBeAgent = useTranslations("join.statistic.whyBeAgent");
  const statisticDataItems = [
    { title: "1973", description: translationStatsLabel("founded") },
    { title: "+300", description: translationStatsLabel("agents") },
    { title: "+30", description: translationStatsLabel("offices") },
    {
      title: `+145 ${translationStatsLabel("thousand")}`,
      description: translationStatsLabel("globalAgents"),
    },
    {
      title: `+10 ${translationStatsLabel("thousand")}`,
      description: translationStatsLabel("properties"),
    },
    {
      title: `15.2 ${translationStatsLabel("years")}`,
      description: translationStatsLabel("average"),
    },
  ];

  const [items, setItems] = useState<{
    title: string;
    description: string;
  }[]>(statisticDataItems)

  const width = useWidth();
  const fetchStatistics = () => getStatistics();
  const { mutate, data, isLoading } = useMutation(["estadisticas"], fetchStatistics, {
    onSuccess: ({ data }) => {
      statisticDataItems[1].title = data.agents_count.toString() ?? 0;
      statisticDataItems[2].title = data.agencies_count.toString() ?? 0;
      setItems(statisticDataItems);
    },
  });

  useEffect(() => {
    mutate();
  }, []);

  return (
    <Wrapper>
      <StatisticContainer className="container">
        <StatisticContent>
          <StatisticTitle>
            {translation.rich("title", {
              red: (chunks) => <StatisticTitleRed>{chunks}</StatisticTitleRed>,
              light: (chunks) => (
                <StatisticTitleLight>{chunks}</StatisticTitleLight>
              ),
            })}
          </StatisticTitle>
          {!["xs", "sm"].includes(width) && (
            // <JoinRemaxForm>

            <StatisticButton>
              <a href="https://reclutamiento.remaxrd.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                {translation("joinFamily")}
              </a>
            </StatisticButton>
            // </JoinRemaxForm>
          )}
          <StatisticSubContainer>
            <StatisticSubtitle>
              {translationWhyBeAgent("title")}
            </StatisticSubtitle>
            <StatisticText>{translationWhyBeAgent("benefits")}</StatisticText>
            <StatisticText>{translationWhyBeAgent("info")}</StatisticText>
          </StatisticSubContainer>
          <StatisticData>
            {items.map((item, index) => (
              <StatisticDataItem key={index}>
                <StatisticDataTitle>{item.title}</StatisticDataTitle>
                <StatisticDataDescription>
                  {item.description}
                </StatisticDataDescription>
              </StatisticDataItem>
            ))}
          </StatisticData>
          {["xs", "sm"].includes(width) && (
            // <JoinRemaxForm>
            <StatisticButton style={{ marginTop: 30 }}>
              <a href="https://reclutamiento.remaxrd.com/" target="_blank" rel="noopener noreferrer" style={{ color: 'white' }}>
                {translation("joinFamily")}
              </a>
            </StatisticButton>
            // </JoinRemaxForm>
          )}
        </StatisticContent>

        <StatisticBackground>
          <Image
            src="/images/image-optimize/agent-remax-join-franchise.webp"
            alt="Buscando agente inmobiliario remax RD"
          />
        </StatisticBackground>
      </StatisticContainer>
    </Wrapper>
  );
}

const sharedCss = css`
  margin-left: 6%;
  @media screen and (max-width: 767px) {
    margin-left: 0;
  }
`;

const Wrapper = styled.section`
  padding: 110px 0 0;
  margin-bottom: -5px;
  @media screen and (max-width: 1299px) {
    overflow: hidden;
  }
  @media screen and (max-width: 450px) {
    padding: 100px 0 0;
  }
`;

const StatisticContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 1299px) {
    position: relative;
    padding-bottom: 140px;
  }
`;

const StatisticContent = styled.section`
  width: calc(100% - 534px);
  @media screen and (max-width: 1299px) {
    width: calc(100% - 234px);
  }
  @media screen and (max-width: 991px) {
    width: 100%;
  }
`;

const StatisticTitle = styled.h2`
  ${sharedCss}
  font-size: 3.313rem;
  font-weight: 500;
  text-align: left;
  max-width: 505px;
  margin-left: 77px;
  text-transform: none;
  margin-bottom: 26px;
  line-height: 30px;
  color: var(--color-blue-main);
  @media screen and (max-width: 767px) {
    font-size: 2.313rem;
    text-align: center;
  }
`;

const StatisticTitleRed = styled.span`
  font-size: 2.188rem;
  font-weight: 700;
  color: #e92027;
  display: block;
  margin-left: 19%;
  @media screen and (max-width: 767px) {
    font-size: 1.688rem;
    text-align: center;
    margin-left: 0;
  }
`;

const StatisticTitleLight = styled.span`
  font-size: 1.938rem;
  font-weight: 300;
  display: block;
  margin-left: 36%;
  @media screen and (max-width: 767px) {
    font-size: 1.438rem;
    text-align: center;
    margin-left: 0;
  }
`;

const StatisticBackground = styled.div`
  max-width: 634px;
  align-self: flex-end;
  @media screen and (max-width: 1299px) {
    position: absolute;
    right: -15%;
    bottom: 0;
  }
  @media screen and (max-width: 1200px) {
    position: absolute;
    right: -30%;
    bottom: 0;
  }
  @media screen and (max-width: 991px) {
    display: none;
  }
`;

const Image = styled.img`
  width: 100%;
  border-style: none;
`;

const StatisticButton = styled(Button)`
  max-width: 265px;
  margin-left: 20%;
  font-weight: 700;
  text-decoration: none;
  @media screen and (max-width: 767px) {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
`;

const StatisticSubtitle = styled.h3`
  ${sharedCss}
  margin-top: 94px;
  font-size: 1.438rem;
  font-weight: 700;
  margin-bottom: 17px;
  color: var(--color-blue-main);
  @media screen and (max-width: 450px) {
    margin-top: 50px;
  }
`;

const StatisticSubContainer = styled.div`
  width: 90%;
  margin: 0 auto;
`;

const StatisticText = styled.p`
  ${sharedCss}
  font-size: 0.938rem;
  font-weight: 500;
  color: #99999b;
  margin-bottom: 21px;
  max-width: 625px;
`;

const StatisticData = styled.div`
  margin-top: 65px;
  display: flex;
  justify-content: space-between;
  max-width: 750px;
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media screen and (max-width: 700px) {
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

const StatisticDataItem = styled.div`
  max-width: 113px;
  @media screen and (max-width: 767px) {
    margin: 15px;
  }
  @media screen and (max-width: 575px) {
    max-width: 140px;
  }
  @media screen and (max-width: 450px) {
    width: 50%;
    margin: 15px 0;
    padding: 0px;
  }
`;

const StatisticDataTitle = styled.span`
  font-size: 1.678rem;
  font-weight: 700;
  color: #5e5e5e;
  margin-bottom: 4px;
  display: block;
  white-space: nowrap;
  text-align: center;
  @media screen and (max-width: 700px) {
    font-size: 35px;
  }
  @media screen and (max-width: 575px) {
    max-width: 140px;
    font-size: 26px;
  }
  @media screen and (max-width: 450px) {
    text-align: left;
  }
`;

const StatisticDataDescription = styled.span`
  font-size: 0.865rem;
  font-weight: 700;
  color: #68686a;
  display: block;
  text-align: center;
  @media screen and (max-width: 450px) {
    text-align: left;
  }
`;

export default Statistic;
